import { useCurrentWarning } from './web3Warning.hooks';
import Web3Warning from './web3Warning.component';

export { Web3Warning, useCurrentWarning };
